<template>
  <div
    v-if="config && config.styles" 
    :class="[
      {'wrapper--padding': mosokna},
      'wrapper'
    ]">
    <HeaderMobile v-if="isMobile"/>
    <Aside />
    <Main v-if="!isMobile"/>
    <SliderPreview :id="true"/>
    <transition name="fade">
      <Popup
        v-if="currentPopup.state"
        ref="popup"
        :popup="currentPopup.name"/>
    </transition>
    <transition name="fade">
      <Popover
        v-if="currentPopover.state"
        ref="popover"
        :popover="currentPopover.name"/>
    </transition>
  </div>
</template>

<script>
import {
  mapActions,
  mapMutations,
  mapState,
  mapGetters
} from 'vuex';

export default {
  name: 'Customizer',

  props: {
    uuid: {
      type: String,
      default: '',
    },
  },

  components: {
    Main: () => import('./components/Main'),
    Aside: () => import('./components/Aside'),
    HeaderMobile: () => import('./components/header/HeaderMobile'),
    SliderPreview: () => import('./components/slider/SliderPreview'),
    Popup: () => import('@/elements/Popup/Popup'),
    Popover: () => import('@/elements/Popover/Popover'),
  },

  computed: {
    ...mapState({
      currentPopup: state => state.common.currentPopup,
      currentPopover: state => state.common.currentPopover,
      models: state => state.models.models,
      config: state => state.user.config,
      basket: state => state.basket.basket,
      currency: state => state.basket.currency,
    }),
    ...mapGetters('user', ['getDealer']),
    currencySymbol() {
      if (this.getDealer?.currency?.symbol) {
        return this.getDealer.currency.symbol
      }

      return this.currency;
    },
  },

  watch: {
    basket: {
      handler(val) {
        if (!this.mosokna && val && this.$route.name !== 'edit-order') {
          localStorage.basket = JSON.stringify(this.basket);
          localStorage.basket_currency = this.currencySymbol;
        }
      },
      deep: true,
    }
  },

  methods: {
    ...mapActions('basket', [
      'loadBasketOrder',
    ]),

    ...mapActions('slider', [
      'loadInteriors',
      'loadWindows',
    ]),

    ...mapMutations('models', [
      'updateModelSizeHeight',
      'updateModelSizeWidth',
      'updateQueryParamsLogo',
      'updateQueryParamsBasket',
      'updateQueryParamsModel',
      'updateQueryParamsElement',
      'updateQueryParamsSize',
    ]),

    ...mapMutations('basket', [
      'updateBasketEditOrder',
      'updateBasketLS',
      'updateCurrency',
    ]),
  },

  created() {
    this.loadInteriors();
    this.loadWindows();

    if (!this.mosokna && this.$route.name !== 'edit-order') {
      if (localStorage.basket_date) {
        const date = JSON.parse(localStorage.basket_date);
        let currentDate = Date.parse(new Date());
        let days = (currentDate - Date.parse(date))/86400000;
        if (Math.round(days) > 7) {
          localStorage.basket_date = JSON.stringify(new Date);
          localStorage.basket = JSON.stringify([]);
        }
      } else {
        localStorage.basket_date = JSON.stringify(new Date);
      }

      if (localStorage.basket) {
        this.updateBasketLS(JSON.parse(localStorage.basket));
      }

      this.updateCurrency(localStorage.currency ? localStorage.currency : '₽');
    }
  },

  mounted() {
    if (this.$route.name === 'edit-order') {
      this.loadBasketOrder({
        'id': this.$route.params.uuid,
      }).then(res => {
        this.updateBasketEditOrder(true);
      })
    }
    let params = this.$route.query;
    if (params.hide) {
      this.updateQueryParamsElement(params.hide);
    }
    if (params.size) {
      let array = params.size.split(",");
      array = array.map(x => {
        return x.trim();
      });
      this.updateQueryParamsSize(array);
      this.updateModelSizeWidth(Number(params.size.split(',')[0]));
      this.updateModelSizeHeight(Number(params.size.split(',')[1]));
    }
  },
};
</script>

<style scoped lang="scss">
.wrapper {
  max-width: 1540px;
  padding: 0 20px;
  padding-bottom: 10px;
  margin: 0 auto;
  position: relative;

  &--padding {
    padding: 0;
  }

  @media(max-width: $desktop) {
    flex-direction: column;
    display: flex;
    width: 100%;
    min-height: 100%;
    position: static;
    padding: 0;
    padding-top: 45px;
  }
}
</style>
